<div class="p-4 gap-4 bg-white rounded-lg p-6 shadow">
  <h2 class="text-xl font-semibold mb-4">Resource Form - {{ mode | titlecase }} Mode</h2>

  <div class="mb-4 flex gap-2">
    <button mat-stroked-button color="primary" *ngIf="mode === 'view'" (click)="setMode('edit')">Edit</button>
    <button mat-stroked-button color="accent" *ngIf="mode === 'edit'" (click)="setMode('view')">Cancel</button>
  </div>

  <form [formGroup]="resourceForm" (ngSubmit)="onSubmit()"
    class="grid grid-cols-1 md:grid-cols-2 gap-4 bg-white rounded-lg p-6 shadow" novalidate>

    <!-- Company Info Card -->
    <mat-card class="col-span-2">
      <mat-card-title>Company Info</mat-card-title>
      <div formGroupName="company" class="grid grid-cols-1 md:grid-cols-2 gap-4 p-4">
        <div>
          <mat-label>Name</mat-label>

          <mat-form-field appearance="outline">
            <input matInput formControlName="name">
          </mat-form-field>
        </div>
        <div>
          <mat-label>Address</mat-label>

          <mat-form-field appearance="outline">
            <textarea matInput formControlName="address" [rows]="1"></textarea>
          </mat-form-field>
        </div>
        <div>
          <mat-label>Logo URL</mat-label>

          <mat-form-field appearance="outline" class="md:col-span-2">
            <input matInput formControlName="logo">
          </mat-form-field>
        </div>

      </div>
    </mat-card>

    <!-- Form Fields Two Per Row -->
    <div>
      <mat-label>Type of Machine</mat-label>

      <mat-form-field appearance="outline">
        <input matInput formControlName="typeOfMachine">
      </mat-form-field>
    </div>
    <div>
      <mat-label>Contact Person</mat-label>

      <mat-form-field appearance="outline">
        <input matInput formControlName="contactPerson">
      </mat-form-field>
    </div>

    <div>
      <mat-label>Supervisor</mat-label>

      <mat-form-field appearance="outline">
        <input matInput formControlName="supervisor">
      </mat-form-field>
    </div>
    <div>
      <mat-label>Mobile Number</mat-label>

      <mat-form-field appearance="outline">
        <input matInput formControlName="mobileNumber">
      </mat-form-field>
    </div>
    <div>
      <mat-label>Email</mat-label>

      <mat-form-field appearance="outline">
        <input matInput formControlName="email">
      </mat-form-field>
    </div>
    <div>
      <mat-label>Current Location</mat-label>

      <mat-form-field appearance="outline">
        <input matInput formControlName="currentLocation">
      </mat-form-field>
    </div>
    <div>
      <mat-label>Capacity</mat-label>

      <mat-form-field appearance="outline">
        <mat-select formControlName="capacity">
          <mat-option *ngFor="let cap of capacities" [value]="cap">{{ cap }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div>
      <mat-label>Make</mat-label>

      <mat-form-field appearance="outline">
        <input matInput formControlName="make">
      </mat-form-field>
    </div>
    <div>
      <mat-label>Purchase Date</mat-label>

      <mat-form-field appearance="outline">
        <input matInput [matDatepicker]="picker1" formControlName="purchaseDate">
        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
        <mat-datepicker #picker1></mat-datepicker>
      </mat-form-field>
    </div>
    <div>
<div>
        <mat-label>Maintenance Date</mat-label>

   <mat-form-field appearance="outline">
        <input matInput [matDatepicker]="picker2" formControlName="maintenanceDate">
        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
        <mat-datepicker #picker2></mat-datepicker>
      </mat-form-field>
</div>
     
    </div>
    <div>
      <mat-label>Last Maintenance Date</mat-label>

      <mat-form-field appearance="outline">
        <input matInput [matDatepicker]="picker3" formControlName="lastMaintenanceDate">
        <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
        <mat-datepicker #picker3></mat-datepicker>
      </mat-form-field>
    </div>
    <div>
<div>
        <mat-label>Machine Condition</mat-label>

      <mat-form-field appearance="outline">
        <mat-select formControlName="machineCondition">
          <mat-option *ngFor="let option of machineConditions" [value]="option">{{ option }}</mat-option>
        </mat-select>
      </mat-form-field>
      </div>
    </div>
    <div>
      <mat-label>Tracker Number</mat-label>

      <mat-form-field appearance="outline">
        <input matInput formControlName="trackerNumber">
      </mat-form-field>
    </div>
    <div>
      <mat-label>History</mat-label>

      <mat-form-field appearance="outline" class="md:col-span-2">
        <textarea matInput formControlName="history"></textarea>
      </mat-form-field>
    </div>
    <div>
      <mat-label>Status</mat-label>

      <mat-form-field appearance="outline">
        <mat-select formControlName="status">
          <mat-option *ngFor="let status of statusOptions" [value]="status">{{ status }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Section Title -->
    <h3 class="text-lg font-semibold col-span-2 mt-4">Inspection Engineer</h3>
    <div>
      <mat-label>Name</mat-label>

      <mat-form-field appearance="outline">
        <input matInput formControlName="inspectionEngineer">
      </mat-form-field>
    </div>
    <div>

      <mat-label>Location</mat-label>

      <mat-form-field appearance="outline">
        <input matInput formControlName="engineerLocation">
      </mat-form-field>
    </div>
    <div>
      <mat-label>Email</mat-label>

      <mat-form-field appearance="outline">
        <input matInput formControlName="engineerEmail">
      </mat-form-field>
    </div>
    <div>
      <mat-label>Mobile</mat-label>

      <mat-form-field appearance="outline">
        <input matInput formControlName="engineerMobile">
      </mat-form-field>
    </div>

    <!-- Submit Buttons -->
    <div class="col-span-2 flex justify-end gap-2">
      <button mat-raised-button color="primary" type="submit" *ngIf="mode === 'edit'">Submit</button>
      <button mat-raised-button color="primary" type="submit" *ngIf="mode === 'add'">Submit</button>
    </div>
  </form>
</div>